let idCounter = 0;

export function generateId(): string {
	return String(idCounter++);
}
